import { STARTING_MODULE_STORE_KEY } from '../constants';
import { LoadedStatus } from '../models';

export default (state: GlobalState) =>
    state[STARTING_MODULE_STORE_KEY].status === LoadedStatus.Loaded;
